import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, Suspense as _Suspense, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19852c58"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "create-addition-template-content"
}
const _hoisted_2 = { class: "template-type-content" }
const _hoisted_3 = {
  key: 0,
  class: "iconfont icon-xuanzhong1"
}
const _hoisted_4 = {
  key: 1,
  class: "iconfont icon-moren1"
}
const _hoisted_5 = { class: "template-type-text" }
const _hoisted_6 = {
  key: 0,
  class: "iconfont icon-xuanzhong1"
}
const _hoisted_7 = {
  key: 1,
  class: "iconfont icon-moren1"
}
const _hoisted_8 = { class: "template-type-text" }

import { t } from '@/plugins/i18n'
import { ref, watch, onMounted, computed } from 'vue'
import { addCustomerAdditionTemplateApi, updateCustomerAdditionTemplateApi } from '@/apis/addition'
import { getAllIncludeCheckCustomerApi, getShippingConfigTypeApi } from '@/apis/setup'
import Drawer from '@/components/common/Drawer.vue'
import AdtOrder from './AdtOrder.vue'
import DeliAdt from '@/components/additional/DeliAdt.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import store, { getWarehouseCode, isJA } from '@/store'
import { confirmEdit } from '@/util/useConfirm'
import { COUNTRY } from '@/global'
import { request } from '@/config/request/interceptors'
import { CategoryAdaptInfo } from '@/service/settlement'
// isJumpSetPriceTemplate 一口价弹窗跳转设置一口价套餐附加项模版

export default /*#__PURE__*/_defineComponent({
  props: ['cfg', 'visible', 'proxy', 'countryCode', 'isJumpSetPriceTemplate'],
  emits: ['update:visible', 'submit'],
  setup(__props, { emit: emits }) {

const props = __props


const form:any = ref({
  templateName: '',
  templateType: 1,
  remark: '',
  priceType: !!props.isJumpSetPriceTemplate,
  categoryCode: ''
})
const formRef = ref()
const adtOrderRef = ref()
const deliAdtRef = ref()
const loading = ref(false)
const formRule: any = {
  templateName: [
    { required: true, message: t('必填'), trigger: 'blur' }
  ],
  templateType: [
    { required: true, message: t('必填'), trigger: 'blur' }
  ]
}
const handleAdt = (addition: any) => {
  formRef.value.validate((valid: any) => {
    if (valid) {
      let api = props.proxy?.additionTemplateId ? updateCustomerAdditionTemplateApi : addCustomerAdditionTemplateApi

      const params:any = {
        ...form.value,
        reqDTOList: addition.map((v) => {
          return {
            ...v,
            spotCheckFlag: form.value.priceType ? 0 : v.spotCheckFlag,
            spotCheckRatio: form.value.priceType ? null : v.spotCheckRatio
          }
        }),
        additionTemplateId: props.proxy?.additionTemplateId,
        warehouseCode: getWarehouseCode(props.countryCode === COUNTRY.KR),
        supportAllInclude: !!form.value.priceType,
        templateScene: props.proxy?.templateScene
      }
      if (!form.value.priceType) {
        delete params.categoryCode
      }

      if (props.proxy.templateScene === 'QUICK_RESPONSE' && props.proxy.customerShopId === '0') {
        api = addCustomerAdditionTemplateApi
      }
      api(params).then((res: any) => {
        if (res.success) {
          ElMessage.success(t('操作成功'))
          emits('update:visible', false)
          emits('submit', params)
        }
      })
    }
  })
}
const close = () => {
  confirmEdit(() => emits('update:visible', false), () => { })
}
watch(() => props.visible, () => {
  form.value = {
    templateName: props.proxy?.templateName || (props.isJumpSetPriceTemplate ? t('一价全包商品附加项套餐') : ''),
    templateType: props.proxy?.templateType || 1,
    remark: props.proxy?.remark || '',
    priceType: props.isJumpSetPriceTemplate ? true : props.proxy.supportAllInclude === 1,
    categoryCode: props.proxy.categoryCode ?? priceTypeList?.value?.[0]?.categoryCode ?? ''
  }
})
const changeRadio = (type:number) => {
  if (props.isJumpSetPriceTemplate || props.proxy?.templateScene === 'QUICK_RESPONSE') return
  form.value.templateType = type
  form.value.priceType = false
  props.proxy.itemInfoRespDTOList = []
}
const priceTypeList = ref<CategoryAdaptInfo[]>()
const isWhiteListUser = ref(false)
onMounted(async () => {
  const { data } = await request.settlement.allInclude.categoryAdaptInfo()
  priceTypeList.value = data
  const result = await getAllIncludeCheckCustomerApi()
  isWhiteListUser.value = result.data.supportAllInclude
})
const show = computed(() => {
  return props.proxy.supportAllInclude === 1 || isWhiteListUser.value
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(Drawer, {
    visible: __props.visible,
    "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
    size: "722px",
    showBtn: false,
    onBeforeClose: close
  }, {
    default: _withCtx(() => [
      (__props.visible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_el_form, {
              model: form.value,
              "label-width": "100px",
              rules: formRule,
              class: "form",
              ref: (_value, _refs) => {
                _refs['formRef'] = _value
                formRef.value = _value
              }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: _unref(t)('组合名称'),
                  prop: "templateName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: form.value.templateName,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.templateName) = $event)),
                      disabled: __props.proxy.templateScene=='QUICK_RESPONSE',
                      maxlength: "50"
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _unref(t)('类型2'),
                  prop: "templateType"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", {
                        class: _normalizeClass([{ active: form.value.templateType === 1, disabled: __props.proxy.templateScene === 'QUICK_RESPONSE' }, 'template-type-item']),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (changeRadio(1)))
                      }, [
                        (form.value.templateType === 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_3))
                          : (_openBlock(), _createElementBlock("span", _hoisted_4)),
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('商品附加项组合')), 1)
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass([{ active: form.value.templateType === 2, disabled: __props.isJumpSetPriceTemplate || __props.proxy.templateScene === 'QUICK_RESPONSE' }, 'template-type-item']),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (changeRadio(2)))
                      }, [
                        (form.value.templateType === 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6))
                          : (_openBlock(), _createElementBlock("span", _hoisted_7)),
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('发货附加项组合')), 1)
                      ], 2)
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                (form.value.templateType === 1 && _unref(isJA)() && _unref(show) && __props.countryCode === 'CN')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: _unref(t)('套餐类型'),
                      prop: "priceType"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox, {
                          modelValue: form.value.priceType,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.priceType) = $event)),
                          label: _unref(t)('一价全包'),
                          disabled: __props.isJumpSetPriceTemplate
                        }, null, 8, ["modelValue", "label", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true),
                (form.value.templateType === 1 && form.value.priceType && _unref(isJA)() && _unref(show))
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      label: _unref(t)('商品类型'),
                      prop: "categoryCode",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: form.value.categoryCode,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.categoryCode) = $event)),
                          placeholder: _unref(t)('请选择'),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(priceTypeList.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.categoryNameJp,
                                value: item.categoryCode!,
                                key: item.categoryCode
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, {
                  label: _unref(t)('备注'),
                  prop: "remark"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: form.value.remark,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.remark) = $event)),
                      maxlength: "200"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["model"]),
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                (form.value.templateType === 1)
                  ? (_openBlock(), _createBlock(AdtOrder, {
                      key: 0,
                      list: __props.proxy.itemInfoRespDTOList,
                      "onUpdate:list": _cache[6] || (_cache[6] = ($event: any) => ((__props.proxy.itemInfoRespDTOList) = $event)),
                      onCommit: handleAdt,
                      hideAdtLoop: true,
                      noAdt: true,
                      countryCode: props.countryCode,
                      ref: (_value, _refs) => {
                        _refs['adtOrderRef'] = _value
                        adtOrderRef.value = _value
                      },
                      loading: loading.value,
                      onBeforeClose: close,
                      "no-spot": form.value.priceType
                    }, null, 8, ["list", "countryCode", "loading", "no-spot"]))
                  : (_openBlock(), _createBlock(DeliAdt, {
                      key: 1,
                      cfg: __props.proxy.itemInfoRespDTOList,
                      "onUpdate:cfg": _cache[7] || (_cache[7] = ($event: any) => ((__props.proxy.itemInfoRespDTOList) = $event)),
                      ref: (_value, _refs) => {
                        _refs['deliAdtRef'] = _value
                        deliAdtRef.value = _value
                      },
                      countryCode: props.countryCode,
                      onBeforeClose: _cache[8] || (_cache[8] = (e) => e && close()),
                      onSave: handleAdt,
                      hideAdtLoop: true
                    }, null, 8, ["cfg", "countryCode"]))
              ]),
              _: 1
            }))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})